import React from 'react'
import BlogNavigator from './components/blog/index'


export default  ({ ownerUid, bCode, BlogTitle, dir="ltr"}) => {
  return <div> <BlogNavigator ownerUid={ownerUid} bCode={bCode} BlogTitle={BlogTitle} dir={dir}/> </div>
}

